import * as React from "react";
import { Save, LogOut } from "lucide-react";
import { Loader2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface LogoutConfirmationModalProps {
  isOpen: boolean;
  onConfirmSave: () => void;
  onConfirmDiscard: () => void;
  onCancel: () => void;
  isSaving?: boolean;
}

const LogoutConfirmationModal: React.FC<LogoutConfirmationModalProps> = ({
  isOpen,
  onConfirmSave,
  onConfirmDiscard,
  onCancel,
  isSaving = false,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && !isSaving && onCancel()}>
      <DialogContent className="max-w-[450px] z-[2100]">
        <DialogHeader>
          <DialogTitle>Sign out</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-4 py-2">
          <DialogDescription className="text-[15px] leading-relaxed">
            Do you want to save changes to the current document before signing out?
          </DialogDescription>
          <DialogDescription className="text-[13px] text-muted-foreground">
            If you discard, unsaved changes will be lost.
          </DialogDescription>

          {isSaving && (
            <div className="flex items-center gap-2.5 text-[13px] text-primary px-4 py-3 bg-primary/10 rounded-lg">
              <Loader2 className="h-4 w-4 animate-spin" />
              <span>Saving document...</span>
            </div>
          )}
        </div>
        <DialogFooter className="flex justify-end items-center w-full">
          <div className="flex gap-2.5">
            <Button
              variant="outline"
              onClick={onConfirmDiscard}
              disabled={isSaving}
              className="text-red-600 border-red-200 hover:bg-red-50 hover:text-red-700 whitespace-nowrap"
            >
              <LogOut className="h-4 w-4 mr-2" />
              Discard and sign out
            </Button>
            <Button
              onClick={onConfirmSave}
              disabled={isSaving}
              className="whitespace-nowrap"
            >
              {isSaving ? (
                <>
                  <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                  Saving...
                </>
              ) : (
                <>
                  <Save className="h-4 w-4 mr-2" />
                  Save and sign out
                </>
              )}
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LogoutConfirmationModal;



